import React from "react";
import PropTypes from "prop-types";
import { Form, Button, Message } from "semantic-ui-react";
import InlineError from "../messages/InlineError";
import settings from "../../settings";
// import { getTermsOfUseLink } from "../../utils/PageHelper";

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        password: "",
        username: "",
        termscheck: "",
        appname: settings.appName,
      },
      loading: false,
      errors: {},
    };
  }

  onChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });

  onTermsChange = (e) =>
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.checked },
    });

  onSubmit = (e) => {
    e.preventDefault();
    const errors = this.validate(this.state.data);
    this.setState({ errors });
    if (Object.keys(errors).length === 0) {
      if (this.props) {
        this.props.resetAppErrorMessage();
      }
      this.setState({ loading: true });
      this.props
        .submit(this.state.data)
        .then(() => this.setState({ loading: false }))
        .catch((err) => {
          this.setState({ errors: err.response.data.errors, loading: false });
        });
    }
  };

  validate = (data) => {
    const errors = {};
    if (!data.username) {
      errors.username = "User ID cannot be blank";
      document.getElementById("username").focus();
    } else if (!data.password) {
      errors.password = "Password cannot be blank";
      document.getElementById("password").focus();
    // } else if (!data.termscheck) {
    //   errors.termscheck = "Please check the terms box";
    //   document.getElementById("termscheck").focus();
    }
    return errors;
  };

  render() {
    const { data, errors, loading } = this.state;
    // const termsOfUseUrl = getTermsOfUseLink();
    return (
      <Form onSubmit={this.onSubmit} loading={loading}>
        {(errors.global || this.props.loginError) && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{errors.global || this.props.loginError}</p>
          </Message>
        )}
        {this.props.errorMessage && (
          <Message negative>
            <Message.Header>Something went wrong</Message.Header>
            <p>{this.props.errorMessage}</p>
          </Message>
        )}
        <Form.Field error={!!errors.username}>
          <label className="font-family" htmlFor="username">
            User ID:
          </label>
          <input
            type="text"
            id="username"
            name="username"
            tabIndex="a"
            autoComplete="username"
            placeholder="Enter your user ID"
            value={data.username}
            onChange={this.onChange}
          />
          {errors.username && <InlineError text={errors.username} />}
        </Form.Field>
        <Form.Field error={!!errors.password}>
          <label className="font-family" htmlFor="password">
            Password:
          </label>
          <input
            type="password"
            id="password"
            name="password"
            tabIndex="b"
            autoComplete="current-password"
            placeholder="Enter your password"
            value={data.password}
            className="col-md-1"
            onChange={this.onChange}
          />
          {errors.password && <InlineError text={errors.password} />}
        </Form.Field>
        <div className="new-search-availability">
          <p>
            New Searches Available: Try our <br />
            <span className="red-text">
              Email and Social Media Searches now!
            </span>
          </p>
        </div>
        <Button primary>Login</Button>
      </Form>
    );
  }
}

LoginForm.propTypes = {
  submit: PropTypes.func.isRequired,
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js